import type * as lazyFunctions from "./lazyFunctions";
import { LazyBootModule, LazyAction } from "owa-bundling-light";

const lazyModule: LazyBootModule<typeof lazyFunctions> = new LazyBootModule(() => import(/* webpackChunkName: "AppBootFreezeDry" */ "./lazyFunctions"), { name: "AppBootFreezeDry" });

export const lazyKickOffFreezeDryProxy: LazyAction<typeof lazyFunctions.lazyKickOffFreezeDry.importAndExecute, typeof lazyModule> = new LazyAction(lazyModule, m => m.lazyKickOffFreezeDry.importAndExecute);

export const lazySetShouldInitializeFreezeDryProxy: LazyAction<typeof lazyFunctions.lazySetShouldInitializeFreezeDry.importAndExecute, typeof lazyModule> = new LazyAction(lazyModule, m => m.lazySetShouldInitializeFreezeDry.importAndExecute);
